<!-- Start of Footer Block -->

<footer class="jds-footer">
  <div class="container">
    <div class="top-section sitemap">
      <h2 class="jds-footer-sitemap-header text-start">
        <img src="/assets/images/sg-courts-logo-white.svg " alt="" aria-hidden="true" />
        <span class="visually-hidden">Singapore Courts</span>
      </h2>
    </div>
    <hr class="divider" />
    <div class="bottom-section">
      <div class="row">
        <div class="col-lg-9">
          <div class="footer-links">
            <a
              href=" https://tech.gov.sg/report_vulnerability "
              target=" _blank "
              >Report Vulnerability <i class="fal fa-external-link ms-1"></i
            ></a>
            <a [routerLink]="['/app/pages/privacy-statement']"
              >Privacy Statement</a
            >
            <a [routerLink]="['/app/pages/terms-and-conditions']"
              >Terms of Use
            </a>
            <a href=" https://www.reach.gov.sg/ " target=" _blank "
              >Reach.gov.sg <i class="fal fa-external-link ms-1"></i
            ></a>
          </div>
        </div>
        <div class="col-lg-3 mobile-mt-3 copyright text-right">
          <div>© 2023 Government of Singapore</div>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- End of Footer Block -->
